import { FeatureFlag } from '@mews-distributor/common';
import { TaxBreakDown as UITaxBreakDown } from '@mews-distributor/ui';

import { useFeatureFlag } from '@mews/framework';
import { useAppSelector } from '../../../../utils/redux';
import { getTaxBreakDown } from './selectors';

export const TaxBreakDown = () => {
    const dccFlowEnabled = useFeatureFlag(FeatureFlag.dccFlowEnabled);
    const taxBreakDown = useAppSelector((state) =>
        getTaxBreakDown(state, { shouldSelectedCurrencyBeUsed: dccFlowEnabled })
    );

    return <UITaxBreakDown {...taxBreakDown} />;
};
